/** Copy for the appearance controls (header toggle and account-menu row). */
export const THEME_MODE_COPY = {
  switchToDark: "Switch to dark mode",
  switchToLight: "Switch to light mode",
  appearanceLabel: "Appearance",
  options: [
    { id: "light", label: "Light", ariaLabel: "Light appearance" },
    { id: "dark", label: "Dark", ariaLabel: "Dark appearance" },
    { id: "system", label: "System", ariaLabel: "Match system appearance" },
  ],
} as const;
